import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import Divider from "@mui/material/Divider";
import LoadingButton from "../../../../components/mui/lab/LoadingButton";
import Alert from "../../../../components/mui/material/Alert";
import QuoteButton from "../../../../components/QuoteButton";
import { useThemeContext } from "../../../ThemeContext";
import { operationTypes, brandPrimary, operationForms } from "../../../../constants";
var tKey = "contexts.ExchangeContext.CreateExchangeDialog.ExchangeWizardForm.ExchangeWizardFormQuoteStep";
var selector = formValueSelector("exchangeWizard");
function ExchangeWizardFormQuoteStep(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useThemeContext = useThemeContext(),
    customColors = _useThemeContext.customColors,
    addCustomColor = _useThemeContext.addCustomColor;
  var price = useSelector(function (state) {
    return selector(state, "price");
  });
  var currency = price.currency;
  var market = price.market;
  var type = useSelector(function (state) {
    return selector(state, "type");
  });
  var boost = useSelector(function (state) {
    return selector(state, "boost");
  });
  var broker = useSelector(function (state) {
    return selector(state, "broker");
  });
  var investmentItem = useSelector(function (state) {
    return selector(state, "variantInvestmentItemRoot");
  });
  var user = useSelector(function (state) {
    return selector(state, "user");
  });
  var investmentItemAmount = useSelector(function (state) {
    return selector(state, "investmentItemAmount");
  });
  var currencyAmount = useSelector(function (state) {
    return selector(state, "currencyAmount");
  });
  var investmentItemAmountAvailable = useSelector(function (state) {
    return selector(state, "investmentItemAmountAvailable");
  });
  var currencyAmountAvailable = useSelector(function (state) {
    return selector(state, "currencyAmountAvailable");
  });
  var investmentAccount = useSelector(function (state) {
    return selector(state, "investmentAccount");
  });
  var exchangeNow = useSelector(function (state) {
    return selector(state, "exchangeNow");
  });
  var postOperationsCall = useSelector(function (state) {
    return state.apiCalls.postOperations[operationForms.NEW] || {};
  });
  function handleClickConfirm(quote) {
    props.change("quote", quote);
    props.change("exchangeNow", true);
  }
  useEffect(function () {
    addCustomColor(investmentItem.id.toString(), {
      main: investmentItem.pictureBackgroundColorHex || brandPrimary,
      focus: investmentItem.pictureBackgroundColorHex || brandPrimary,
      light: investmentItem.pictureBackgroundColorHex || brandPrimary,
      dark: investmentItem.pictureBackgroundColorHex || brandPrimary,
      contrastText: "#ffffff",
      text: investmentItem.pictureBackgroundColorHex || brandPrimary
    });
  }, [investmentItem]);
  if (!customColors[investmentItem.id.toString()]) return null;
  return /*#__PURE__*/React.createElement(Alert, {
    severity: investmentItem.id.toString(),
    sx: {
      justifyContent: "center",
      alignItems: "center",
      width: "100%"
    },
    className: "border"
  }, broker.fetchQuoteListenerBeanName && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: ".5rem 1rem"
    }
  }, /*#__PURE__*/React.createElement(QuoteButton, {
    operation: {
      type: type,
      broker: broker,
      market: market,
      currency: currency,
      investmentItem: investmentItem,
      user: user,
      investmentItemAmount: investmentItemAmount,
      boost: boost
    },
    loading: postOperationsCall.isFetching,
    investmentItemAmountAvailable: investmentItemAmountAvailable,
    cashAvailable: currencyAmountAvailable,
    onClickConfirm: handleClickConfirm,
    disabled: !boost && (!investmentAccount || !investmentAccount.enabledAt || type === operationTypes.BUY && currencyAmount > currencyAmountAvailable || type === operationTypes.SELL && investmentItemAmount > investmentItemAmountAvailable)
  })), /*#__PURE__*/React.createElement(Divider, null, t("".concat(tKey, ".or")))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: ".5rem 1rem"
    }
  }, /*#__PURE__*/React.createElement(LoadingButton, {
    fullWidth: true,
    type: "submit",
    variant: "contained",
    color: "secondary",
    loading: postOperationsCall.isFetching && !exchangeNow,
    style: {
      fontWeight: 600
    }
  }, t("".concat(tKey, ".addToCart")))));
}
export default ExchangeWizardFormQuoteStep;